import { useEffect, useState } from "react";
import { ImageIcon, FileText, Link2, Mic, FolderOpen, FolderInput } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Attachment } from "../Chat";

const TABS = [
  ["media", "Media", ImageIcon, (m) => /^(image|video)\//.test(m.attachment?.content_type || "")],
  ["docs", "Docs", FileText, (m) => m.attachment && !/^(image|video|audio)\//.test(m.attachment.content_type || "")],
  ["links", "Links", Link2, (m) => !!m.link || /https?:\/\//.test(m.text || "")],
  ["voice", "Voice", Mic, (m) => /^audio\//.test(m.attachment?.content_type || "")],
];
const linkOf = (m) => m.link || (m.text || "").match(/https?:\/\/\S+/)?.[0];
const when = (m) => new Date(m.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

export function MediaDialog({ open, onOpenChange, msgs, title, onSave }) {
  const [tab, setTab] = useState("media");
  useEffect(() => { if (open) setTab("media"); }, [open, title]);
  const live = msgs.filter((m) => !m.deleted);
  const [, , , test] = TABS.find((t) => t[0] === tab);
  const rows = live.filter(test).reverse();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="chat-media-dialog" className="max-h-[88vh] max-w-2xl overflow-hidden">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><FolderOpen className="h-4 w-4 text-[#15966B]" />Media storage · {title}</DialogTitle></DialogHeader>
        <div className="flex gap-1.5 overflow-x-auto">
          {TABS.map(([k, l, Icon, fn]) => (
            <button key={k} data-testid={`chat-media-tab-${k}`} onClick={() => setTab(k)}
              className={`flex shrink-0 items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${tab === k ? "bg-[#15966B] text-white" : "bg-zinc-100 text-zinc-600 hover:bg-zinc-200"}`}>
              <Icon className="h-3.5 w-3.5" />{l} <span className="opacity-70">{live.filter(fn).length}</span>
            </button>
          ))}
        </div>
        <div data-testid={`chat-media-list-${tab}`} className={`thin-scroll max-h-[62vh] overflow-y-auto pr-1 ${tab === "media" ? "grid grid-cols-2 gap-3 sm:grid-cols-3" : "space-y-2"}`}>
          {rows.map((m, i) => (
            <div key={m.id} data-testid={`chat-media-item-${tab}-${i}`} className="min-w-0 overflow-hidden rounded-lg border border-zinc-100 p-2 [&_*]:max-w-full">
              {tab === "links" ? (
                <a href={linkOf(m)} target="_blank" rel="noreferrer" className="block break-all text-sm font-medium text-[#15966B] underline">{linkOf(m)}</a>
              ) : <Attachment a={m.attachment} by={m.author} testid={`chat-media-${tab}-${i}`} />}
              <div className="mt-1 flex items-center justify-between gap-1 text-[11px] text-zinc-500"><span className="truncate">{m.author} · {when(m)}</span>
                {m.attachment?.id && onSave && <button data-testid={`chat-media-save-${tab}-${i}`} title="Save to project files" onClick={() => onSave(m)} className="shrink-0 rounded p-1 text-[#15966B] hover:bg-[#15966B]/10"><FolderInput className="h-3.5 w-3.5" /></button>}</div>
            </div>
          ))}
          {!rows.length && <div className="col-span-full py-10 text-center text-sm text-zinc-400">Nothing shared here yet.</div>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
